<script setup lang="ts">
import { computed } from 'vue';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '~/components/ui/dialog';
import { Button, type ButtonVariants } from '~/components/ui/button';

const props = withDefaults(
	defineProps<{
		modelValue: boolean;
		title: string;
		description?: string;
		confirmLabel?: string;
		cancelLabel?: string;
		confirmVariant?: ButtonVariants['variant'];
	}>(),
	{
		description: '',
		confirmLabel: 'Conferma',
		cancelLabel: 'Annulla',
		confirmVariant: 'secondary',
	},
);

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void;
	(e: 'confirm'): void;
	(e: 'cancel'): void;
}>();

const open = computed({
	get: () => props.modelValue,
	set: (value: boolean) => emit('update:modelValue', value),
});

function handleCancel() {
	emit('cancel');
	open.value = false;
}

function handleConfirm() {
	emit('confirm');
}
</script>

<template>
	<Dialog v-model:open="open">
		<DialogContent
			class="!rounded-none sm:!rounded-none !left-4 !right-4 !translate-x-0 sm:!left-1/2 sm:!right-auto sm:!-translate-x-1/2 max-w-[calc(100vw-2rem)] sm:max-w-lg"
		>
			<DialogHeader>
				<DialogTitle>{{ title }}</DialogTitle>
				<DialogDescription v-if="description">
					{{ description }}
				</DialogDescription>
			</DialogHeader>
			<DialogFooter class="flex-col gap-3 sm:flex-row sm:gap-2">
				<Button
					variant="outline"
					class="w-full sm:w-auto"
					type="button"
					@click="handleCancel"
				>
					{{ cancelLabel }}
				</Button>
				<Button
					:variant="confirmVariant"
					class="w-full sm:w-auto"
					type="button"
					@click="handleConfirm"
				>
					{{ confirmLabel }}
				</Button>
			</DialogFooter>
		</DialogContent>
	</Dialog>
</template>

